// extracted by mini-css-extract-plugin
export default {"wrapper":"apphome_wrapper__5cspd","mainWrapper":"apphome_mainWrapper__1WTBt","contentWrapper":"apphome_contentWrapper__e-yqI","content":"apphome_content__UuYmZ"};